const cappedViewportSpacing = (maximumPixels: number, viewportWidth: number) =>
  `min(${maximumPixels}px, ${viewportWidth}vw)`;

export const layout = {
  layout: {
    contentInset: cappedViewportSpacing(100, 6),
    compactContentInset: cappedViewportSpacing(100, 5),
    sectionSpacing: cappedViewportSpacing(60, 4),
    compactSectionSpacing: cappedViewportSpacing(60, 3),
    columnGap: cappedViewportSpacing(80, 4),
    wideSpacing: cappedViewportSpacing(100, 4),
    extraWideSpacing: cappedViewportSpacing(200, 8),
  },
};
